const device = {
  deviceModel: 'Model',
  deviceIMEI: 'IMEI',
  deviceExtra: 'Extra',
  devicePhoneNo: 'PhoneNo',
  releaseDate: 'Release Date',
  renewalDate: 'Renewal Date',
  finallyOnline: 'Finally Online',
  devicePower: 'Power',
  onlineStatu: 'Online Statu',
  bandStatu: 'Band Statu',
  deviceImage: 'Image',
  bandDestroy: 'Destroyed',
  bandOK: 'Ok',
  bandUp: 'Up band destroyed',
  bandDown: 'Down band destroyed',
  total: 'Total',
  vacancy: 'Vacancy',
  other: 'Other',
  overView: 'Overview',
  deviceNumber: 'Amount',
  deviceStatusNormal: 'Normal',
  deviceStatusUnbound: 'Unbound',
  incoming: 'Incoming',
  modifyOrg: 'Modify org',
  packUp: 'Pack up',
  expand: 'Expand',
  IMEISearchPlaceholder: 'Enter the IMEI number to search',
  manuallyChoose: 'Manually choose',
  deviceExportSuccess: 'The file was uploaded successfully. {total} device was imported and {repeatNum} duplicate devices were imported',
  deviceExportFailed: 'File upload failed',
  noModifiedDevices: 'No modified devices',
  modifiedSuccess: 'Success',
  deviceModifyTemplate: 'Device modify template',
  remark: 'Remark',
  newRemark: 'New Remark',
  securitySeal: 'Security Seal',
  newSecuritySeal: 'New Security Seal',
  changeRemark: 'Change Remark',
}
export default device